var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreenLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 500 500",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M500 250H0",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 40,
  stroke: "#26890c",
  fill: "transparent",
  "data-name": "Path 280374"
})));
export default SvgGreenLine;